import { render } from "./lang.vue?vue&type=template&id=68bb4f42"
import script from "./lang.vue?vue&type=script&lang=js"
export * from "./lang.vue?vue&type=script&lang=js"

import "./lang.vue?vue&type=style&index=0&id=68bb4f42&rel=stylesheet%2Fscss&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"lang.vue"]])

export default __exports__